import { MarketSignal } from '@/modules/market-signals/model/market-signals/market-signal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './market-signals.module.css';

import { useState } from 'react';
import { faTimeline } from '@fortawesome/free-solid-svg-icons';
import MarketSignalSourceModal from '@/modules/market-signals/components/market-signals/market-signal-source-modal';
import { SignalEntryComponent } from '@/modules/market-signals/components/market-signals/signal-entry-component';

export default function MarketSignalSourceButton({
  signal,
  entry,
}: {
  signal: MarketSignal;
  entry: SignalEntryComponent;
}) {
  const [show, setShow] = useState<boolean>(false);

  const onClose = () => {
    setShow(false);
  };

  return (
    <>
      <span
        className={styles.clipboardButton}
        onClick={() => setShow(true)}
        key={`source-button-${signal._id}`}
      >
        <FontAwesomeIcon icon={faTimeline} />
      </span>
      <MarketSignalSourceModal show={show} setShow={onClose} signal={signal} entry={entry} />
    </>
  );
}
